export const calculateRevenue = (price) => {
  const fee = price * 0.05 + 0.5;
  return price - fee;
};
